<section class="accounting-firm-register-wrapper">
  <div class="box-container">
    <div class="accounting-firm-topic">
      <!-- desktop and tablet heading -->
      <div
        class="accounting-firm-topic__heading accounting-firm-topic__heading--desktop color-white"
        [innerHtml]="'NEW_ACCOUNTING_FIRM.REGISTER_SECTION.HEADING' | translate"
      >
      </div>
      <!-- mobile heading -->
      <div
        class="accounting-firm-topic__heading accounting-firm-topic__heading--mobile color-white"
        [innerHtml]="'NEW_ACCOUNTING_FIRM.REGISTER_SECTION.HEADING_MOBILE' | translate"
      >
      </div>

      <div
        class="accounting-firm-topic__heading-detail"
        [innerHtml]="'NEW_ACCOUNTING_FIRM.REGISTER_SECTION.DETAIL' | translate"
      >
      </div>
    </div>

    <div class="box">
      <div class="box__btn">
        <a
          id="tracking-findaccountingfirm1"
          rel="nofollow"
          routerLink="/accountingfirm/become-our-partner"
          (click)="functionPage('become-our-partner')"
          class="flowbtn app-btn box__btn--layout"
        >
          {{ 'NEW_ACCOUNTING_FIRM.REGISTER_SECTION.BUTTON' | translate }}</a
        >
      </div>
    </div>
  </div>
</section>
